/* ═══════════════════════════════════════════════════════
   FRONTIER¹ · Shared JS · v15
   Place in: assets/frontier-scroll-reveal.js
   Load via: <script src="{{ 'frontier-scroll-reveal.js' | asset_url }}" defer></script>
   in theme.liquid before </body>
   ═══════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Scroll reveal */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.06 });

  document.querySelectorAll('.f1-sr').forEach(function (el) {
    io.observe(el);
  });

  /* Nav solid on scroll */
  var nav = document.getElementById('f1-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('solid', window.scrollY > 40);
    }, { passive: true });
  }
})();
